module.exports = __webpack_public_path__ + "img/plus.02c41c9d.svg";